module.exports = __webpack_public_path__ + "media/assets/icon-outline-cart-7a7a5d1d6ff943334ab55825e920c74b.svg";